// Components==============
import { motion } from 'framer-motion';
import React from 'react';
// =========================

const WaterfallBubbles = React.memo(() => (
    <>
        {/* Small waterfall */}
        <g>
            <motion.circle
                animate={{
                    scale: [1, 0.9, 1, 0.9, 1.1, 1],
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                    delay: 2,
                }}
                cx="4258.1"
                cy="1642.31"
                r="6.43"
                fill="#fff"
                strokeWidth="0"
            />
            <motion.circle
                animate={{
                    scale: [1, 0.9, 1, 0.9, 1.1, 1],
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                    delay: 1,
                }}
                cx="4264.54"
                cy="1638.83"
                r="5.26"
                fill="#fff"
                strokeWidth="0"
            />
            <motion.circle
                animate={{
                    scale: [1, 0.9, 1, 0.9, 1.1, 1],
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                    delay: 0,
                }}
                cx="4251.17"
                cy="1645.59"
                r="3.75"
                fill="#fff"
                strokeWidth="0"
            />
        </g>
        {/* left bubbles */}
        <g>
            <motion.circle
                animate={{
                    scale: [1, 0.9, 1, 0.9, 1.1, 1],
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                    delay: 1,
                }}
                cx="4880.05"
                cy="2488.45"
                r="10.71"
                fill="#fff"
                strokeWidth="0"
            />
            <motion.circle
                animate={{
                    scale: [1, 0.9, 1, 0.9, 1.1, 1],
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                }}
                cx="4895.55"
                cy="2480.49"
                r="14.85"
                fill="#fff"
                strokeWidth="0"
            />
            <motion.circle
                animate={{
                    scale: [1, 0.9, 1, 0.9, 1.1, 1],
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                    delay: 2,
                }}
                cx="4868.36"
                cy="2495.35"
                r="7.56"
                fill="#fff"
                strokeWidth="0"
            />
        </g>
        {/* Middle bubbles */}
        <g>
            <motion.circle
                animate={{
                    scale: [1, 0.9, 1, 0.9, 1.1, 1],
                }}
                transition={{
                    duration: 2.5,
                    repeat: Infinity,
                }}
                cx="4947.51"
                cy="2449.83"
                r="15.32"
                fill="#fff"
                strokeWidth="0"
            />
            <motion.circle
                animate={{
                    scale: [1, 0.9, 1, 0.9, 1.1, 1],
                }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                    delay: 1,
                }}
                cx="4969.67"
                cy="2438.45"
                r="21.24"
                fill="#fff"
                strokeWidth="0"
            />
            <motion.circle
                animate={{
                    scale: [1, 0.9, 1, 0.9, 1.1, 1],
                }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                    delay: 1,
                }}
                cx="4930.79"
                cy="2459.69"
                r="10.81"
                fill="#fff"
                strokeWidth="0"
            />
            <motion.circle
                animate={{
                    scale: [1, 0.9, 1, 0.9, 1.1, 1],
                }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                }}
                cx="4991.21"
                cy="2425"
                r="10.81"
                fill="#fff"
                strokeWidth="0"
            />
        </g>
        {/* Right bubbles */}
        <g>
            <motion.circle
                animate={{
                    scale: [1, 0.9, 1, 0.9, 1.1, 1],
                }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                    delay: 1,
                }}
                cx="5024.11"
                cy="2405.28"
                r="10.71"
                fill="#fff"
                strokeWidth="0"
            />
            <motion.circle
                animate={{
                    scale: [1, 0.9, 1, 0.9, 1.1, 1],
                }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                }}
                cx="5034.82"
                cy="2399.48"
                r="8.76"
                fill="#fff"
                strokeWidth="0"
            />
        </g>
    </>
));

WaterfallBubbles.displayName = 'WaterfallBubbles';
export default WaterfallBubbles;
